import React, {Component} from 'react';
import {connect} from 'react-redux';
import Step from '../parts/Step';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import {Maybe} from '../../utils/logging';
import _ from 'lodash';
import {setLanguageIndex, metricConversion} from '../../utils/helpers';
import * as actions from '../../actions';

class BathtubContent extends Component {

    /**
    * handleStepName
    * @param number
    * @param names
    * @returns {string}
    */
    handleStepName(number, names) {
        const step = 'step';
        return `${step}${names[number]}`;
    }

    calculateSize(type) {
        const getValue = (field) => {
            return Maybe.of(field)
            .map((field) => {
                return parseFloat(field.CurrentValue);
            })._value || 0;
        }
        if (type === 'lange') {
            if(parseInt(this.props.bathtub.VAR_ABM.CurrentValue) === 1) {
                return (parseInt(this.props.bathtub.W_LAENGE.CurrentValue));
            } else {
                const w_laenge = getValue(this.props.bathtub.W_LAENGE);
                const SO45 = getValue(this.props.bathtub.SO45);
                const SO81 = getValue(this.props.bathtub.SO81);
                return w_laenge + SO45 + SO81;
            }
        }
        if (type === 'breite') {
            if (parseInt(this.props.bathtub.VAR_ABM.CurrentValue) === 1) {
                return (parseInt(this.props.bathtub.W_BREITE.CurrentValue));
            } else {
                const w_breite = getValue(this.props.bathtub.W_BREITE);
                const SO23 = getValue(this.props.bathtub.SO23);
                const SO67 = getValue(this.props.bathtub.SO67);
                return w_breite + SO23 + SO67;
            }
        }
    }

    updateContent(stepName, index, arr) {
        const details = [];
        switch(stepName) {

            case 'One':
                Maybe.of(this.props.bathtub.W_BREITE && this.props.bathtub.W_LAENGE)
                    .map(() => {
                        return this.props.bathtub.W_BREITE.CurrentValue && this.props.bathtub.W_LAENGE.CurrentValue
                    })
                    .map(() => {
                        if (parseInt(this.props.bathtub.VAR_ABM.CurrentValue) === 0) {
                            details.push(`${this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.1`)} ${this.props.bathtub.W_LAENGE.CurrentValue} x ${this.props.bathtub.W_BREITE.CurrentValue}`);
                        }
                    });
                Maybe.of(this.props.bathtub.VAR_ABM)
                .map((var_abm) => {
                        // details.push(`${this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.2`)} ${this.props.bathtub.LAENGE.CurrentValue} x ${this.props.bathtub.BREITE.CurrentValue}`);
                    details.push(`${this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.2`)} ${this.calculateSize('lange')} cm x ${this.calculateSize('breite')} cm`);
                })
                break;
            case 'Two':
                const ZT = (field) => {
                return Maybe.of(field)
                    .map((field) => {
                        return parseInt(field.CurrentValue);
                    })
                    .map((field_value) => {
                        details.push(`${this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.1`)} Z${this.props.bathtub.ZT.CurrentValue}`);
                    })
                };
                ZT(this.props.bathtub.ZT);

                const ZARGE = (field) => {
                    return Maybe.of(this.props.bathtub[field])
                        .map((field) => {
                            return field.CurrentValue;
                        })
                        .map((field_value) => {
                            if(field_value === '0') {
                                Maybe.of(this.props.bathtub[`${field}_switch`])
                                .map((zswitch) => {
                                    return zswitch.CurrentValue;
                                })
                                .map((zswitch_value) => {
                                    if(zswitch_value !== '0') {
                                        details.push(this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.summary.${field}.${zswitch_value}`));
                                    }
                                });
                            }
                            if(field_value !== '0') {
                                const measure = this.props.bathtub[field.replace(/Z/g, "ZM")].CurrentValue;
                                details.push(`${this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.summary.${field}.${field_value}`)} ${measure} cm`);
                            }
                        })
                };

                ['Z23', 'Z45', 'Z67', 'Z81'].forEach((field) => {
                    ZARGE(field);
                });
                break;
            case 'Three':
                const CORNER = (field) => {
                    let corner, choice;
                    return Maybe.of(this.props.bathtub[field])
                        .map((field) => {
                            return field.CurrentValue;
                        })
                        .map((field_value) => {
                            if(field_value !== '0' && field_value !== '01') {
                                corner = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.${field}`);
                                choice = this.props.bathtub[field].Values.Value.find(((el) => {return parseInt(el.Code) === parseInt(field_value)})).Description[`${setLanguageIndex(this.props.currentLanguge)}`];
                                details.push(`${corner}: ${choice}`);
                            }
                        })
                };

                ['EA12', 'EA34', 'EA56', 'EA78'].forEach((field) => {
                    CORNER(field);
                });
                break;
            case 'Four':
                let name = '', pos;

                const lochType = () => {
                    return Maybe.of(this.props.bathtub.lochbohrungen_select.CurrentValue)
                    .map((value) => {
                        if (value === 'L1') {
                            name = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.L1`);
                        } else if (value === 'L2') {
                            name = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.L2`);
                        } else if (value === 'AT') {
                            name = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.AT`);
                            return 'ATP';
                        }
                        return value;
                    })
                    .map((value) => {
                        return position(value).join();
                    })
                }
                const position = (value) => {
                    return Maybe.of(this.props.bathtub[value]).map((val) => {
                        pos = val.Values.Value.find((el) => { return parseInt(el.Code) === parseInt(this.props.bathtub[value].CurrentValue)}).Description[`${setLanguageIndex(this.props.currentLanguge)}`];
                        details.push(`${name} ${pos}`)
                        return true;
                    });
                }
                lochType()
                .orElseFun(() => {
                    details.push(name);
                });
                break;
            case 'Five':
                let splash = '', sp;
                const SP = () => {
                    return Maybe.of(parseInt(this.props.bathtub.SP.CurrentValue))
                        .map((SP_Value) => {
                            sp = this.props.bathtub.SP.Values.Value.find(((el) => {return parseInt(el.Code) === SP_Value})).Description[`${setLanguageIndex(this.props.currentLanguge)}`];
                            details.push(`${splash} ${sp}`);
                            return true;
                        })
                }
                const SPV = () => {
                    return Maybe.of(this.props.bathtub.SP_activator)
                        .map((SPV) => {
                            return parseInt(SPV.CurrentValue);
                        })
                        .map((SPV_Value) => {
                            splash = this.props.translate(`BATHTUB.stepFive.menu.body.SPV`);
                            return splash;
                        })
                        .map((splash) => {
                            return SP()
                            .join()
                        })
                }

                SPV()

                break;

            case 'Six':
                let gr = '', gft1, gfp1, content;

                const GFT1 = () => {
                    return Maybe.of(this.props.bathtub.GFT1)
                        .map((GFT1) => {
                            gr = (GFT1.CurrentValue !== '00') ? this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.GR`) : '';
                            return gr;
                        })
                        .map((gr) => {
                            return Maybe.of(parseInt(this.props.bathtub.GFT1.CurrentValue))
                            .map((GFT1_Value) => {
                                gft1 = this.props.bathtub.GFT1.Values.Value.find((el) => { return parseInt(el.Code) === GFT1_Value}).Description[`${setLanguageIndex(this.props.currentLanguage)}`];
                                return gft1;
                            })
                            .map((gft1) => {
                                return GFP1(gft1)
                                .orElseFun(() => {
                                    details.push(`${gr} ${gft1}`);
                                    return true;
                                })
                            })
                            .join()
                        })
                };

                const GFP1 = () => {
                    return Maybe.of(this.props.bathtub.GFP1.CurrentValue)
                        .map((GFP1_Value) => {
                            gfp1 = this.props.bathtub.GFP1.Values.Value.find((el) => { return el.Code === GFP1_Value}).Description[`${setLanguageIndex(this.props.currentLanguage)}`];
                            details.push(`${gr} ${gft1} ${gfp1}`);
                            return true;
                        })
                }

                GFT1()
                .orElseFun(() => {
                    details.push(gr);
                })

                break;
            case 'Seven':
                let whirlsystem, ws, alg;

                const WS = () => {
                    return Maybe.of(this.props.bathtub.MISSING_WHIRLSYSTEM)
                        .map((MISSING_WHIRLSYSTEM) => {
                            return parseInt(MISSING_WHIRLSYSTEM.CurrentValue);
                        })
                        .map((MISSING_WHIRLSYSTEM_Value) => {
                            whirlsystem = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.whirlsystem`);
                            return Maybe.of(parseInt(this.props.bathtub.WS.CurrentValue))
                                .map((ws_value) => {
                                    ws = this.props.bathtub.WS.Values.Value.find((el) => { return parseInt(el.Code) === ws_value}).Description[`${setLanguageIndex(this.props.currentLanguage)}`];
                                    return ALG(ws_value)
                                    .orElseFun(() => {
                                        details.push(`${whirlsystem} ${ws}`)
                                        return true;
                                    })
                                })
                                .join()
                        })
                }

                const ALG = (ws_value) => {
                    return Maybe.of(this.props.bathtub.ALG)
                        .map((alg) => {
                            return alg.CurrentValue;
                        })
                        .map((alg_value) => {
                            return _.isArray(this.props.bathtub.ALG.Values.Value);
                        })
                        .map((isArray) => {
                            if (this.props.bathtub.ALG.Values.Value.find((el) => { return el.Code === this.props.bathtub.ALG.CurrentValue})) {
                                alg = this.props.bathtub.ALG.Values.Value.find((el) => { return el.Code === this.props.bathtub.ALG.CurrentValue }).Description[`${setLanguageIndex(this.props.currentLanguage)}`];
                                let alg_text = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.ALG`);
                                details.push(`${whirlsystem}: ${ws}`);
                                details.push(`${alg_text}: ${alg}`);
                            }
                            return true;
                        })
                }

                WS()
                    .orElseFun(() => {
                        details.push(whirlsystem);
                    });

                const WHIRLFIELD = (field) => {
                    return Maybe.of(this.props.bathtub[field])
                        .map((mfield) => {
                            return mfield.CurrentValue;
                        })
                        .map((whirl_value) => {
                            if(whirl_value === '1') {
                                details.push(this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.${field}`));
                            }
                        })
                };

                ['FL2', 'WM', 'TA', 'SW2'].forEach((field) => {
                    WHIRLFIELD(field);
                });

                break;

            case 'Eight':
                let soundsystem, model;
                const SOUNDSYSTEM = (field) => {
                    return Maybe.of(field)
                        .map((field) => {
                            return parseInt(field.CurrentValue)
                        })
                        .map((field_value) => {
                            soundsystem = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.soundsystem`);
                            return MODEL(parseInt(this.props.bathtub.SOUNDSYSTEM.CurrentValue));
                        })
                }

                const MODEL = (sound) => {
                    return Maybe.of(sound)
                        .map((sound) => {
                            model = this.props.bathtub.SOUNDSYSTEM.Values.Value.find((el) => { return parseInt(el.Code) === sound }).Description[`${setLanguageIndex(this.props.currentLanguage)}`]
                            details.push(`${soundsystem} ${model}`);
                            return true;
                        })
                        .join();
                }

                SOUNDSYSTEM(this.props.bathtub.MISSING_SOUNDSYSTEM)
                    .orElseFun(() => {
                        details.push(soundsystem);
                    });

                break;
            case 'Nine':
                const checkboxContent = [];
                const FA = (field) => {
                    return Maybe.of(field)
                        .map((field) => {
                            return parseInt(field.CurrentValue)
                        })
                        .map((fa_value) => {
                            details.push(this.props.bathtub.FA.Values.Value.find((el) => { return  parseInt(el.Code) === fa_value}).Description[`${setLanguageIndex(this.props.currentLanguage)}`]);
                        })
                }

                const ANTIGLISS = (field) => {
                    return Maybe.of(field)
                        .map((field) => {
                            return parseInt(field.CurrentValue);
                        })
                        .map((antigliss_value) => {
                            checkboxContent.push(this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.antigliss`));
                        })
                }

                const GLASSUR = (field) => {
                    return Maybe.of(field)
                        .map((field) => {
                            return parseInt(field.CurrentValue);
                        })
                        .map((glassur_value) => {
                            checkboxContent.push(this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.glassur`));
                        })
                }

                FA(this.props.bathtub.FA);
                ANTIGLISS(this.props.bathtub.GT);
                GLASSUR(this.props.bathtub.OV)
                details.push(checkboxContent.join(', '));

                break;
            default:
                return details;

}
        return details;
    }


    render() {
        let name, value = '';
        return this.props.list.map((el, index, arr) => {
            if(!el){return}
            let details = [];
            if (index === arr.length - 1) {
                name = 'downloadAndContact.title';
            } else {
                name = `${this.props.field}.${this.handleStepName(index, arr)}.menu.title`;
                details = this.updateContent(el, index, arr);
            }
            return (
                <Step
                    key={index}
                    name={this.props.translate(name)}
                    value={value}
                    details={details}
                    currentStep={this.props.currentStep}
                    stepNo={index + 1} />

            );
        });
    }

}

function mapStateToProps({bathtub, locale}) {
    return {
        translate:      getTranslate(locale),
        currentLanguge: getActiveLanguage(locale).code,
        bathtub,
    }
}

export default connect(mapStateToProps, actions)(BathtubContent);



// WEBPACK FOOTER //
// ./src/components/sidebar-menu/BathtubContent.js